import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import BookingConfirmationDetailCard from 'reservations/confirmation/components/BookingConfirmationDetailCard';

type Props = {
  context: {
    body: string;
    header: string;
    button: {
      isEnabled: boolean;
      buttonLink: string;
      buttonText: string;
    };
  };
};

const TextModule = ({ context }: Props) => {
  const { header, body, button } = context;
  const { isEnabled, buttonLink, buttonText } = button;

  const redirectToLink = () => {
    window.open(buttonLink, '_blank');
  };

  return (
    <BookingConfirmationDetailCard header={header}>
      <Typography>{body}</Typography>
      {isEnabled && (
        <Button data-testid="text-module-button" onClick={redirectToLink}>
          {buttonText}
        </Button>
      )}
    </BookingConfirmationDetailCard>
  );
};

export default TextModule;
